import { Trans } from 'react-i18next'

import { StyledSortButton } from '@modules/shortlist/components/ShortlistTable/index.styles'
import { Typography } from '@mui/material'

import { TableHeadCellProps } from '../../types'

export const TableHeadCell = ({ columnTitle, isSortActive, sortOrder, fieldName, openSortPopover }: TableHeadCellProps) => {
  return (
    <>
      <Typography variant="h3">{columnTitle && <Trans>{columnTitle}</Trans>}</Typography>
      <StyledSortButton
        isActive={isSortActive}
        order={isSortActive && sortOrder ? sortOrder : null}
        onClick={({ btnElement }) => {
          openSortPopover({ fieldName, anchor: btnElement })
        }}
      />
    </>
  )
}
